import PropTypes from 'prop-types';

class CheckoutInputElectronic extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        };

        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.selectOption = this.selectOption.bind(this);
    }

    onChange(e) {
        var self = this;

        var str = e.target.value.replace(/^0+/, '').replace(/[^0-9.]/g, '');
        var int = 0;
        var parts;

        if (str.length > 0) {

            if (str.indexOf('.') !== -1) {
                parts = str.split('.');

                if (parts.length > 2)
                    return;

                if (parts[1].length > 2)
                    return;

                var dollar = parts[0] > 0  ? parseInt(parts[0]) * 100 : 0;
                var cent   = 0;

                if (parts[1].length === 1)
                    cent = parts[1] * 10;
                else if (parts[1].length === 2)
                    cent = parts[1];

                int = parseInt(dollar) + parseInt(cent);

            } else {
                int = parseInt(str) * 100;
            }
        }

        this.props.onChange({
            str : str,
            int : int,
            type: this.props.value.type,
            icon: this.props.value.icon,
        });
    }

    onBlur(type) {
        var val = this.props.value.str;

        if (val.indexOf('.') !== -1) {
            val = val.split('.');

            if (val[0].length === 0)
                val[0] = '0';

            if (val[1].length === 0)
                val[1] = '00';

            if (val[1].length === 1)
                val[1] = val[1]+'0';

            this.props.onChange({
                str : val[0]+'.'+val[1],
                int : this.props.value.int,
                type: this.props.value.type,
                icon: this.props.value.icon,
            });
        }
    }

    selectOption(e) {
        var value = e.target.value;
        var selected = _.find(this.props.options, o => o.value === value);
        this.props.onChange({
            str : '',
            int : 0,
            type: selected.value,
            icon: selected.icon,
        });
    }

    render() {
        if(this.props.options.length === 0) {
            return null;
        }

        return (
            <div className='checkout-input'>
                <div className='checkout-input__title'>
                    { 
                        this.props.options.length === 1 ?
                        this.props.options[0].name.toUpperCase() :
                        <select className='input-text-1'
                            disabled={this.props.paid || this.props.disabled}
                            value={this.props.value.type}
                            onChange={this.selectOption}
                            style={{ padding: 5, width: 120, position: 'relative', left: -35, top: -10}}
                        >
                            { this.props.options.map(x => <option value={x.value} key={x.value}>{x.name + (this.props.paid ? ' - Paid' : '')}</option>)}
                        </select>
                    }
                </div>

                { this.props.value.icon &&
                    <img
                        src={this.props.value.icon}
                        className='checkout-input__electronic' />
                }

                <input
                    disabled={this.props.paid}
                    type='text'
                    value={this.props.value.str}
                    onChange={this.onChange}
                    onBlur={this.onBlur}
                    placeholder={this.props.placeholder || '0.00'} />
            </div>
        );
    }
}

CheckoutInputElectronic.propTypes = {
    disabled: PropTypes.bool,
    value: PropTypes.shape({
        str: PropTypes.string,
        icon: PropTypes.string,
        type: PropTypes.string,
        int: PropTypes.number,
    }),
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array,
};

export default CheckoutInputElectronic;



// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/CheckoutInputElectronic.react.jsx